import {useTranslation} from '@aboutyou/i18n';
import {COLORS, ContentPopperProps, SIZE} from '@aboutyou/ui-components';

import {styled} from '@linaria/react';
import React from 'react';
import {BnplInfoRow} from './BnplInfoRow';
import {WhyNotModal, usePopover} from './LearnMorePopover';
import {BnplSlotName} from './constants';

interface DisabledInvoicePaymentSlotProps {
  BnplInfoLayoutComponent: ContentPopperProps['LayoutComponent'];
}

export const DisabledInvoicePaymentSlot = ({
  BnplInfoLayoutComponent,
}: DisabledInvoicePaymentSlotProps) => {
  const {isOpen, openPopover, closePopover} = usePopover('bnpl-why-not');
  const {t} = useTranslation();

  return (
    <SlotWrapper
      slot={BnplSlotName.optionUnderLabel}
      data-testid="disabled-invoice-payment-slot"
    >
      <BnplInfoRow
        color={COLORS['Grey.Shade600']}
        text={t(
          'Unfortunately, we cannot offer payment by invoice for this order.',
        )}
        linkText={t('Why not?')}
        onLinkClick={openPopover}
        linkTestId="why-not-link"
      />

      <WhyNotModal
        open={isOpen}
        onClose={closePopover}
        LayoutComponent={BnplInfoLayoutComponent}
      />
    </SlotWrapper>
  );
};

// There's no spacing token for 12px, so we use SIZE.U3 (0.75rem / 12px) to match the gap under the card icons
const SlotWrapper = styled.div`
  margin-top: ${SIZE.U3};
`;
